import { render, staticRenderFns } from "./illustrationGoodPraticesSection.vue?vue&type=template&id=70cbdb18"
import script from "./illustrationGoodPraticesSection.vue?vue&type=script&lang=ts"
export * from "./illustrationGoodPraticesSection.vue?vue&type=script&lang=ts"
import style0 from "./illustrationGoodPraticesSection.vue?vue&type=style&index=0&id=70cbdb18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports